import { getIsDesktop, getIsTablet, getBrowserClassName } from '../../utils/ua'
import { classList } from '../../utils/dom'
export default function initScreenClassifer() {
  let deviceTypeClassName
  if (getIsDesktop()) {
    deviceTypeClassName = 'isDesktop'
  } else {
    deviceTypeClassName = getIsTablet() ? 'isTablet' : 'isMobile'
  }
  classList(document.body).add(deviceTypeClassName, getBrowserClassName())
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/deviceScreenClassifier.js